import { z } from "zod"

export const getPasswordMessages = (t: (key: string) => string) => {
  return [
    t("config_profile_password_validation_min"),
    t("config_profile_password_validation_number"),
    t("config_profile_password_validation_special"),
    t("config_profile_password_validation_uppercase"),
    t("config_profile_password_validation_lowercase"),
  ]
}

export const getPasswordSchema = (t: (key: string) => string) => {
  const messages = getPasswordMessages(t)
  return z
    .string()
    .min(8, messages[0])
    .regex(/\d/, messages[1])
    .regex(/[^a-zA-Z0-9]/, messages[2])
    .regex(/[A-Z]/, messages[3])
    .regex(/[a-z]/, messages[4])
}
